import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Intentional empty state: quiet icon, short headline, muted description and
 * an optional action. Used instead of fake demo data, always.
 */
export const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center gap-1.5 py-8 text-center",
      className,
    )}
  >
    {Icon ? (
      <div className="mb-1 flex size-9 items-center justify-center rounded-lg border border-border-subtle bg-surface-muted">
        <Icon className="size-4 text-muted-foreground" strokeWidth={1.75} />
      </div>
    ) : null}
    <p className="text-[13px] font-medium text-foreground">{title}</p>
    {description ? (
      <p className="max-w-60 text-[12px] leading-relaxed text-muted-foreground">
        {description}
      </p>
    ) : null}
    {action ? <div className="mt-2">{action}</div> : null}
  </div>
);
